import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {LoginRouteService} from '../login-route.service';
import {debounceTime, filter} from 'rxjs/operators';
import {WindowRef} from '@lifeislife/lifeislife-domain';

@Component({
  selector: 'cf-password-bloc',
  templateUrl: './password-bloc.component.html',
  styleUrls: ['./password-bloc.component.scss'],
  animations: [
    trigger('collapsed', [
      state('false', style({height: 'auto'})),
      state('true', style({height: '0'})),
      transition('false => true', [
        animate('100ms ease-out'),
      ]),
      transition('true => false', [
        animate('100ms ease-out'),
        style({height: '100%'}),
      ]),
    ]),
  ],
})
export class PasswordBlocComponent implements OnInit, OnDestroy {

  collapsed$: Observable<boolean>;

  waitingForMail = true;
  waitingForPassword = true;
  contactMail: string;
  contactPassword: string;

  recoverWanted: boolean;
  recoverSucceeded: boolean;
  recoverCompleted: boolean;
  recovering$: Observable<boolean>;
  recoverError: string | null;

  validating$: Observable<boolean>;
  loginCompleted: boolean;
  loginError: string;


  @ViewChild('theForm')
  private theFormElementRef: ElementRef;
  private subscription: Subscription;


  constructor(
    private loginRouteService: LoginRouteService,
    private windowRef: WindowRef,
  ) {
  }


  ngOnInit(): void {
    this.subscription = new Subscription();

    const lastEmailSubscription = this.loginRouteService.lastUsedMail$
      .subscribe(lastEmail => this.contactMail = lastEmail);
    this.subscription.add(lastEmailSubscription);

    this.collapsed$ = this.loginRouteService.isCollapsed$('password');
    const expandedSubscription = this.collapsed$.pipe(
      filter(c => c === false),
      debounceTime(200),
    ).subscribe(c => this.focusMailInput());
    this.subscription.add(expandedSubscription);

    this.recovering$ = this.loginRouteService.recovering$;
    this.validating$ = this.loginRouteService.authenticatingPassword$;

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


  onFormSubmit() {
    if (this.recoverWanted) {
      this.onRecoverPasswordClick();
    } else {
      this.onPasswordSubmit();
    }
  }

  onPasswordSubmit() {
    this.loginRouteService.authenticatePassword$(this.contactMail, this.contactPassword)
      .subscribe(() => {/* redirected*/
        },
        e => {
          this.loginCompleted = true;
          this.loginError = this.loginRouteService.passwordError;
        },
        () => {
          this.loginCompleted = true;
          this.loginError = this.loginRouteService.passwordError;
        });
  }

  onCloseClick() {
    const window = this.windowRef.getWindow();
    if (window) {
      window.close();
    }
  }

  toggleCollapse() {
    this.loginRouteService.toggleExpanded('password');
  }


  onRememberedPasswordClick() {
    if (this.loginRouteService.isRecovering()) {
      return;
    }
    this.recoverWanted = false;
    this.loginCompleted = false;
    this.recoverCompleted = false;
    this.waitingForPassword = true;
    this.waitingForMail = true;
    this.focusMailInput();
  }

  onRecoverPasswordClick() {
    if (this.loginRouteService.isRecovering()) {
      return;
    }
    this.recoverWanted = true;
    this.recoverCompleted = false;
    this.waitingForPassword = false;

    this.focusMailInput();
    // Check if form is valid and submit directly
    // if (this.contactMail == null || this.contactMail.length === 0) {
    // } else {
    //   this.sendRecoverMail();
    // }
  }

  sendRecoverMail() {
    this.loginRouteService.recoverPassword$(this.contactMail)
      .subscribe(() => {
          this.recoverSucceeded = true;
          this.waitingForPassword = false;
          this.waitingForMail = false;
        }, e => {
          this.recoverSucceeded = false;
          this.recoverCompleted = true;
          this.recoverError = this.loginRouteService.recoverError;
        },
        () => {
          this.recoverCompleted = true;
          this.recoverError = this.loginRouteService.recoverError;
        });
  }

  private focusMailInput() {
    if (this.theFormElementRef) {
      const htmlElement: HTMLFormElement = this.theFormElementRef.nativeElement;
      if (htmlElement) {
        const element: HTMLInputElement = htmlElement.querySelector('input[name=contactMail]');
        if (element && element.focus) {
          element.focus();
        }
      }
    }
  }

}
